<div class="checks-container container-fluid">
  <div *ngFor="let datastream of getDatastreamsArray(); let datastreamIndex = index" class="table-container" [hidden]="datastream?.checks?.length < 1">
    <h6 class="check-header">Checks for {{datastream['property']['name']}} ("{{datastream['property']['description']}}"):</h6>
    <table class="table table-responsive-md table-striped">
      <tr>
        <th *ngFor="let check of datastream?.checks" [hidden]="check?.params?.length < 1">{{check?.name}}
        </th>
      </tr>
      <tr>
        <td *ngFor="let check of datastream?.checks; let checkIndex = index" [hidden]="check?.params?.length < 1">
          <div *ngFor="let param of check?.params; let paramIndex = index">
            <label>
              {{param?.name}} ({{check?.unitOfMeasurement?.name}} {{check?.datum?.name}}):
            </label>
            <input type="text" [disabled]="disableChecksInput()" class="check-input form-control squared" value="{{param?.value}}" oninput="this.value = this.value.replace(/[^-0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/(?!^)-/g, '');"
              [(ngModel)]="this.datastreams[datastreamIndex].checks[checkIndex].params[paramIndex].value" [ngClass]="this.datastreams[datastreamIndex].checks[checkIndex].params[paramIndex].value !==
                         this.datastreamsBackup[datastreamIndex].checks[checkIndex].params[paramIndex].value ?
                         'changed-value' : ''" (ngModelChange)="onModelChange(datastreamIndex, checkIndex)" />
          </div>
        </td>
      </tr>
    </table>
  </div>

</div>
<span *ngIf="this.rights.get('update')">
  <button *ngIf="!isSaveHidden" id="save-button" class="btn custom-button-por-blue" (click)="onSaveClick()">Save
  </button>
</span>
